/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template>
  <div class="container">
    <h1 v-if="user">{{user.username}}'s profile</h1>
    <div >
      <profile-form
        :user="user"
        :fields="fields"
        v-if="user"
      />
    </div>
    <section>
      <v-card class="my-3">
        <v-toolbar card color="grey lighten-3">
          <v-toolbar-title>Multifactor Authentication</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p>MFA configuration is managed via AWS Cognito console.</p>
        </v-card-text>
      </v-card>
      <v-card class="my-3">
        <v-toolbar card color="grey lighten-3">
          <v-toolbar-title>Profile Picture</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p>Profile picture upload has been simplified. Contact admin for changes.</p>
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import AmplifyStore from '../store/store';

export default {
  name: 'Profile',
  data() {
    return {
      fields: [
        { type: 'string', name: 'email', label: 'Email' },
        { type: 'string', name: 'phone_number', label: 'Phone Number' }
      ],
    };
  },
  computed: {
    user() {
      return AmplifyStore.state.user
    },
  }
}
</script>
